import { ErpDiv, ErpMain, ErpSpinner } from "@/components/erp";
import React, { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from '@/redux/hooks'
import Sidebar from './Sidebar'
import TopNav from './TopNav'
import Footer from './Footer'
import { CommandPalette } from '@/components/app'
import { AiLauncher } from '@/components/ai/AiLauncher'
import { useCommandPalette } from '@/hooks'
import BusinessClockBanner from '@/components/app/BusinessClockBanner'

const OutletLoader: React.FC = () => (
  <ErpDiv className="flex h-full w-full items-center justify-center">
    <ErpSpinner />
  </ErpDiv>
)

export const LargeSidebarLayout: React.FC = () => {
  const location = useLocation()
  const tenantIsOnboardingComplete = useAppSelector((state) => state.tenant.onboardingComplete)
  const cp = useCommandPalette()

  const showChrome = !(
    location.pathname.startsWith('/app/onboarding') &&
    !tenantIsOnboardingComplete
  )

  return (
    <ErpDiv className="flex h-screen w-full bg-background overflow-hidden text-foreground">
      {showChrome && <Sidebar />}
      <ErpDiv className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {showChrome && <TopNav />}

        <ErpMain className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6 bg-muted/20 flex flex-col scrollbar-thin scrollbar-thumb-muted scrollbar-track-transparent">
          <BusinessClockBanner />
          {/* Suspense wraps only the Outlet (lazy route content) so shell chrome
              (sidebar/topnav/footer) stays visible during chunk loads. */}
          <ErpDiv className="min-w-0 max-w-full flex-auto">
            <Suspense fallback={<OutletLoader />}>
              <Outlet />
            </Suspense>
          </ErpDiv>
          {showChrome && <ErpDiv className="mt-auto pt-8"><Footer /></ErpDiv>}
          {showChrome && <CommandPalette isOpen={cp.isOpen} initialQuery={cp.initialAction} onOpenChange={(v) => v ? cp.open() : cp.close()} />}
        </ErpMain>
      </ErpDiv>
      {showChrome && <AiLauncher />}
    </ErpDiv>
  );
}

export default LargeSidebarLayout
